module.exports = __webpack_public_path__ + "img/rear-3.bb05ae1a.jpg";